import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

String.prototype.trimChars = function (c) {
    var re = new RegExp("^[" + c + "]+|[" + c + "]+$", "g");
    return this.replace(re,"");
}

/*
let path = window.location.pathname.trimChars('/').split( '/' )
path = path && path[0] ? '/' + path[0] : ''
*/

const API = window.apiUrl + '/v1/admin'
const API_LOGIN_URL = API + '/auth/login'
const API_LOGOUT_URL = API + '/auth/logout'
const API_USER_URL = API +  '/auth/user'
const API_USER_ACL_URL = API +  '/auth/acl/'
const API_VARIABLE = API + '/initialize'

Vue.use(Vuex)

const LOGIN = "LOGIN";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGOUT = "LOGOUT";
const CHECK_SUCCESS = "CHECK_SUCCESS";
const CLIENT_SWITCHED = "CLIENT_SWITCHED"
const WORKSPACE_SWITCHED = "WORKSPACE_SWITCHED"

//document.head.querySelector("[name='X-WEEBOX-CLIENT']").content

export const store = new Vuex.Store({
    state: {
        lang: 'fr',
        ApiExportPreviousRequests: [],
        isLoggedIn: false,
        scope: localStorage.getItem('scope') | {token:null},
        scopes: null,
        workspace: localStorage.getItem('workspace') | {id:0},
        user: null,
        countriesGrouped: null,
        countries: null,
        metrics: null,
        currencies: null,
        taxes: null,
        locales: null,
        loaded: false,
        api: API,
        debugApiUrl: '',
        path: '',
        modules: [],
        timezones: [
            {
                offset:"-12:00",
                id:"Etc/GMT+12",
                name:"(GMT -12:00) Etc/GMT+12"
            },
            {
                offset:"-11:00",
                id:"Etc/GMT+11",
                name:"(GMT -11:00) Etc/GMT+11"
            },
            {
                offset:"-11:00",
                id:"Pacific/Midway",
                name:"(GMT -11:00) Pacific/Midway"
            },
            {
                offset:"-11:00",
                id:"Pacific/Niue",
                name:"(GMT -11:00) Pacific/Niue"
            },
            {
                offset:"-11:00",
                id:"Pacific/Pago_Pago",
                name:"(GMT -11:00) Pacific/Pago_Pago"
            },
            {
                offset:"-11:00",
                id:"Pacific/Samoa",
                name:"(GMT -11:00) Pacific/Samoa"
            },
            {
                offset:"-11:00",
                id:"US/Samoa",
                name:"(GMT -11:00) US/Samoa"
            },
            {
                offset:"-10:00",
                id:"America/Adak",
                name:"(GMT -10:00) America/Adak"
            },
            {
                offset:"-10:00",
                id:"America/Atka",
                name:"(GMT -10:00) America/Atka"
            },
            {
                offset:"-10:00",
                id:"Etc/GMT+10",
                name:"(GMT -10:00) Etc/GMT+10"
            },
            {
                offset:"-10:00",
                id:"HST",
                name:"(GMT -10:00) HST"
            },
            {
                offset:"-10:00",
                id:"Pacific/Honolulu",
                name:"(GMT -10:00) Pacific/Honolulu"
            },
            {
                offset:"-10:00",
                id:"Pacific/Johnston",
                name:"(GMT -10:00) Pacific/Johnston"
            },
            {
                offset:"-10:00",
                id:"Pacific/Rarotonga",
                name:"(GMT -10:00) Pacific/Rarotonga"
            },
            {
                offset:"-10:00",
                id:"Pacific/Tahiti",
                name:"(GMT -10:00) Pacific/Tahiti"
            },
            {
                offset:"-10:00",
                id:"US/Aleutian",
                name:"(GMT -10:00) US/Aleutian"
            },
            {
                offset:"-10:00",
                id:"US/Hawaii",
                name:"(GMT -10:00) US/Hawaii"
            },
            {
                offset:"-09:30",
                id:"Pacific/Marquesas",
                name:"(GMT -09:30) Pacific/Marquesas"
            },
            {
                offset:"-09:00",
                id:"America/Anchorage",
                name:"(GMT -09:00) America/Anchorage"
            },
            {
                offset:"-09:00",
                id:"America/Juneau",
                name:"(GMT -09:00) America/Juneau"
            },
            {
                offset:"-09:00",
                id:"America/Nome",
                name:"(GMT -09:00) America/Nome"
            },
            {
                offset:"-09:00",
                id:"America/Sitka",
                name:"(GMT -09:00) America/Sitka"
            },
            {
                offset:"-09:00",
                id:"America/Yakutat",
                name:"(GMT -09:00) America/Yakutat"
            },
            {
                offset:"-09:00",
                id:"Etc/GMT+9",
                name:"(GMT -09:00) Etc/GMT+9"
            },
            {
                offset:"-09:00",
                id:"Pacific/Gambier",
                name:"(GMT -09:00) Pacific/Gambier"
            },
            {
                offset:"-09:00",
                id:"US/Alaska",
                name:"(GMT -09:00) US/Alaska"
            },
            {
                offset:"-08:00",
                id:"America/Dawson",
                name:"(GMT -08:00) America/Dawson"
            },
            {
                offset:"-08:00",
                id:"America/Ensenada",
                name:"(GMT -08:00) America/Ensenada"
            },
            {
                offset:"-08:00",
                id:"America/Los_Angeles",
                name:"(GMT -08:00) America/Los_Angeles"
            },
            {
                offset:"-08:00",
                id:"America/Metlakatla",
                name:"(GMT -08:00) America/Metlakatla"
            },
            {
                offset:"-08:00",
                id:"America/Santa_Isabel",
                name:"(GMT -08:00) America/Santa_Isabel"
            },
            {
                offset:"-08:00",
                id:"America/Tijuana",
                name:"(GMT -08:00) America/Tijuana"
            },
            {
                offset:"-08:00",
                id:"America/Vancouver",
                name:"(GMT -08:00) America/Vancouver"
            },
            {
                offset:"-08:00",
                id:"America/Whitehorse",
                name:"(GMT -08:00) America/Whitehorse"
            },
            {
                offset:"-08:00",
                id:"Canada/Pacific",
                name:"(GMT -08:00) Canada/Pacific"
            },
            {
                offset:"-08:00",
                id:"Canada/Yukon",
                name:"(GMT -08:00) Canada/Yukon"
            },
            {
                offset:"-08:00",
                id:"Etc/GMT+8",
                name:"(GMT -08:00) Etc/GMT+8"
            },
            {
                offset:"-08:00",
                id:"Mexico/BajaNorte",
                name:"(GMT -08:00) Mexico/BajaNorte"
            },
            {
                offset:"-08:00",
                id:"PST8PDT",
                name:"(GMT -08:00) PST8PDT"
            },
            {
                offset:"-08:00",
                id:"Pacific/Pitcairn",
                name:"(GMT -08:00) Pacific/Pitcairn"
            },
            {
                offset:"-08:00",
                id:"US/Pacific",
                name:"(GMT -08:00) US/Pacific"
            },
            {
                offset:"-08:00",
                id:"US/Pacific-New",
                name:"(GMT -08:00) US/Pacific-New"
            },
            {
                offset:"-07:00",
                id:"America/Boise",
                name:"(GMT -07:00) America/Boise"
            },
            {
                offset:"-07:00",
                id:"America/Cambridge_Bay",
                name:"(GMT -07:00) America/Cambridge_Bay"
            },
            {
                offset:"-07:00",
                id:"America/Chihuahua",
                name:"(GMT -07:00) America/Chihuahua"
            },
            {
                offset:"-07:00",
                id:"America/Creston",
                name:"(GMT -07:00) America/Creston"
            },
            {
                offset:"-07:00",
                id:"America/Dawson_Creek",
                name:"(GMT -07:00) America/Dawson_Creek"
            },
            {
                offset:"-07:00",
                id:"America/Denver",
                name:"(GMT -07:00) America/Denver"
            },
            {
                offset:"-07:00",
                id:"America/Edmonton",
                name:"(GMT -07:00) America/Edmonton"
            },
            {
                offset:"-07:00",
                id:"America/Hermosillo",
                name:"(GMT -07:00) America/Hermosillo"
            },
            {
                offset:"-07:00",
                id:"America/Inuvik",
                name:"(GMT -07:00) America/Inuvik"
            },
            {
                offset:"-07:00",
                id:"America/Mazatlan",
                name:"(GMT -07:00) America/Mazatlan"
            },
            {
                offset:"-07:00",
                id:"America/Ojinaga",
                name:"(GMT -07:00) America/Ojinaga"
            },
            {
                offset:"-07:00",
                id:"America/Phoenix",
                name:"(GMT -07:00) America/Phoenix"
            },
            {
                offset:"-07:00",
                id:"America/Shiprock",
                name:"(GMT -07:00) America/Shiprock"
            },
            {
                offset:"-07:00",
                id:"America/Yellowknife",
                name:"(GMT -07:00) America/Yellowknife"
            },
            {
                offset:"-07:00",
                id:"Canada/Mountain",
                name:"(GMT -07:00) Canada/Mountain"
            },
            {
                offset:"-07:00",
                id:"Etc/GMT+7",
                name:"(GMT -07:00) Etc/GMT+7"
            },
            {
                offset:"-07:00",
                id:"MST",
                name:"(GMT -07:00) MST"
            },
            {
                offset:"-07:00",
                id:"MST7MDT",
                name:"(GMT -07:00) MST7MDT"
            },
            {
                offset:"-07:00",
                id:"Mexico/BajaSur",
                name:"(GMT -07:00) Mexico/BajaSur"
            },
            {
                offset:"-07:00",
                id:"Navajo",
                name:"(GMT -07:00) Navajo"
            },
            {
                offset:"-07:00",
                id:"US/Arizona",
                name:"(GMT -07:00) US/Arizona"
            },
            {
                offset:"-07:00",
                id:"US/Mountain",
                name:"(GMT -07:00) US/Mountain"
            },
            {
                offset:"-06:00",
                id:"America/Bahia_Banderas",
                name:"(GMT -06:00) America/Bahia_Banderas"
            },
            {
                offset:"-06:00",
                id:"America/Belize",
                name:"(GMT -06:00) America/Belize"
            },
            {
                offset:"-06:00",
                id:"America/Cancun",
                name:"(GMT -06:00) America/Cancun"
            },
            {
                offset:"-06:00",
                id:"America/Chicago",
                name:"(GMT -06:00) America/Chicago"
            },
            {
                offset:"-06:00",
                id:"America/Costa_Rica",
                name:"(GMT -06:00) America/Costa_Rica"
            },
            {
                offset:"-06:00",
                id:"America/El_Salvador",
                name:"(GMT -06:00) America/El_Salvador"
            },
            {
                offset:"-06:00",
                id:"America/Guatemala",
                name:"(GMT -06:00) America/Guatemala"
            },
            {
                offset:"-06:00",
                id:"America/Indiana/Knox",
                name:"(GMT -06:00) America/Indiana/Knox"
            },
            {
                offset:"-06:00",
                id:"America/Indiana/Tell_City",
                name:"(GMT -06:00) America/Indiana/Tell_City"
            },
            {
                offset:"-06:00",
                id:"America/Knox_IN",
                name:"(GMT -06:00) America/Knox_IN"
            },
            {
                offset:"-06:00",
                id:"America/Managua",
                name:"(GMT -06:00) America/Managua"
            },
            {
                offset:"-06:00",
                id:"America/Matamoros",
                name:"(GMT -06:00) America/Matamoros"
            },
            {
                offset:"-06:00",
                id:"America/Menominee",
                name:"(GMT -06:00) America/Menominee"
            },
            {
                offset:"-06:00",
                id:"America/Merida",
                name:"(GMT -06:00) America/Merida"
            },
            {
                offset:"-06:00",
                id:"America/Mexico_City",
                name:"(GMT -06:00) America/Mexico_City"
            },
            {
                offset:"-06:00",
                id:"America/Monterrey",
                name:"(GMT -06:00) America/Monterrey"
            },
            {
                offset:"-06:00",
                id:"America/North_Dakota/Beulah",
                name:"(GMT -06:00) America/North_Dakota/Beulah"
            },
            {
                offset:"-06:00",
                id:"America/North_Dakota/Center",
                name:"(GMT -06:00) America/North_Dakota/Center"
            },
            {
                offset:"-06:00",
                id:"America/North_Dakota/New_Salem",
                name:"(GMT -06:00) America/North_Dakota/New_Salem"
            },
            {
                offset:"-06:00",
                id:"America/Rainy_River",
                name:"(GMT -06:00) America/Rainy_River"
            },
            {
                offset:"-06:00",
                id:"America/Rankin_Inlet",
                name:"(GMT -06:00) America/Rankin_Inlet"
            },
            {
                offset:"-06:00",
                id:"America/Regina",
                name:"(GMT -06:00) America/Regina"
            },
            {
                offset:"-06:00",
                id:"America/Resolute",
                name:"(GMT -06:00) America/Resolute"
            },
            {
                offset:"-06:00",
                id:"America/Swift_Current",
                name:"(GMT -06:00) America/Swift_Current"
            },
            {
                offset:"-06:00",
                id:"America/Tegucigalpa",
                name:"(GMT -06:00) America/Tegucigalpa"
            },
            {
                offset:"-06:00",
                id:"America/Winnipeg",
                name:"(GMT -06:00) America/Winnipeg"
            },
            {
                offset:"-06:00",
                id:"CST6CDT",
                name:"(GMT -06:00) CST6CDT"
            },
            {
                offset:"-06:00",
                id:"Canada/Central",
                name:"(GMT -06:00) Canada/Central"
            },
            {
                offset:"-06:00",
                id:"Canada/East-Saskatchewan",
                name:"(GMT -06:00) Canada/East-Saskatchewan"
            },
            {
                offset:"-06:00",
                id:"Canada/Saskatchewan",
                name:"(GMT -06:00) Canada/Saskatchewan"
            },
            {
                offset:"-06:00",
                id:"Etc/GMT+6",
                name:"(GMT -06:00) Etc/GMT+6"
            },
            {
                offset:"-06:00",
                id:"Mexico/General",
                name:"(GMT -06:00) Mexico/General"
            },
            {
                offset:"-06:00",
                id:"Pacific/Galapagos",
                name:"(GMT -06:00) Pacific/Galapagos"
            },
            {
                offset:"-06:00",
                id:"US/Central",
                name:"(GMT -06:00) US/Central"
            },
            {
                offset:"-06:00",
                id:"US/Indiana-Starke",
                name:"(GMT -06:00) US/Indiana-Starke"
            },
            {
                offset:"-05:00",
                id:"America/Atikokan",
                name:"(GMT -05:00) America/Atikokan"
            },
            {
                offset:"-05:00",
                id:"America/Bogota",
                name:"(GMT -05:00) America/Bogota"
            },
            {
                offset:"-05:00",
                id:"America/Cayman",
                name:"(GMT -05:00) America/Cayman"
            },
            {
                offset:"-05:00",
                id:"America/Coral_Harbour",
                name:"(GMT -05:00) America/Coral_Harbour"
            },
            {
                offset:"-05:00",
                id:"America/Detroit",
                name:"(GMT -05:00) America/Detroit"
            },
            {
                offset:"-05:00",
                id:"America/Eirunepe",
                name:"(GMT -05:00) America/Eirunepe"
            },
            {
                offset:"-05:00",
                id:"America/Fort_Wayne",
                name:"(GMT -05:00) America/Fort_Wayne"
            },
            {
                offset:"-05:00",
                id:"America/Guayaquil",
                name:"(GMT -05:00) America/Guayaquil"
            },
            {
                offset:"-05:00",
                id:"America/Havana",
                name:"(GMT -05:00) America/Havana"
            },
            {
                offset:"-05:00",
                id:"America/Indiana/Indianapolis",
                name:"(GMT -05:00) America/Indiana/Indianapolis"
            },
            {
                offset:"-05:00",
                id:"America/Indiana/Marengo",
                name:"(GMT -05:00) America/Indiana/Marengo"
            },
            {
                offset:"-05:00",
                id:"America/Indiana/Petersburg",
                name:"(GMT -05:00) America/Indiana/Petersburg"
            },
            {
                offset:"-05:00",
                id:"America/Indiana/Vevay",
                name:"(GMT -05:00) America/Indiana/Vevay"
            },
            {
                offset:"-05:00",
                id:"America/Indiana/Vincennes",
                name:"(GMT -05:00) America/Indiana/Vincennes"
            },
            {
                offset:"-05:00",
                id:"America/Indiana/Winamac",
                name:"(GMT -05:00) America/Indiana/Winamac"
            },
            {
                offset:"-05:00",
                id:"America/Indianapolis",
                name:"(GMT -05:00) America/Indianapolis"
            },
            {
                offset:"-05:00",
                id:"America/Iqaluit",
                name:"(GMT -05:00) America/Iqaluit"
            },
            {
                offset:"-05:00",
                id:"America/Jamaica",
                name:"(GMT -05:00) America/Jamaica"
            },
            {
                offset:"-05:00",
                id:"America/Kentucky/Louisville",
                name:"(GMT -05:00) America/Kentucky/Louisville"
            },
            {
                offset:"-05:00",
                id:"America/Kentucky/Monticello",
                name:"(GMT -05:00) America/Kentucky/Monticello"
            },
            {
                offset:"-05:00",
                id:"America/Lima",
                name:"(GMT -05:00) America/Lima"
            },
            {
                offset:"-05:00",
                id:"America/Louisville",
                name:"(GMT -05:00) America/Louisville"
            },
            {
                offset:"-05:00",
                id:"America/Montreal",
                name:"(GMT -05:00) America/Montreal"
            },
            {
                offset:"-05:00",
                id:"America/Nassau",
                name:"(GMT -05:00) America/Nassau"
            },
            {
                offset:"-05:00",
                id:"America/New_York",
                name:"(GMT -05:00) America/New_York"
            },
            {
                offset:"-05:00",
                id:"America/Nipigon",
                name:"(GMT -05:00) America/Nipigon"
            },
            {
                offset:"-05:00",
                id:"America/Panama",
                name:"(GMT -05:00) America/Panama"
            },
            {
                offset:"-05:00",
                id:"America/Pangnirtung",
                name:"(GMT -05:00) America/Pangnirtung"
            },
            {
                offset:"-05:00",
                id:"America/Port-au-Prince",
                name:"(GMT -05:00) America/Port-au-Prince"
            },
            {
                offset:"-05:00",
                id:"America/Porto_Acre",
                name:"(GMT -05:00) America/Porto_Acre"
            },
            {
                offset:"-05:00",
                id:"America/Rio_Branco",
                name:"(GMT -05:00) America/Rio_Branco"
            },
            {
                offset:"-05:00",
                id:"America/Thunder_Bay",
                name:"(GMT -05:00) America/Thunder_Bay"
            },
            {
                offset:"-05:00",
                id:"America/Toronto",
                name:"(GMT -05:00) America/Toronto"
            },
            {
                offset:"-05:00",
                id:"Brazil/Acre",
                name:"(GMT -05:00) Brazil/Acre"
            },
            {
                offset:"-05:00",
                id:"Canada/Eastern",
                name:"(GMT -05:00) Canada/Eastern"
            },
            {
                offset:"-05:00",
                id:"Chile/EasterIsland",
                name:"(GMT -05:00) Chile/EasterIsland"
            },
            {
                offset:"-05:00",
                id:"Cuba",
                name:"(GMT -05:00) Cuba"
            },
            {
                offset:"-05:00",
                id:"EST",
                name:"(GMT -05:00) EST"
            },
            {
                offset:"-05:00",
                id:"EST5EDT",
                name:"(GMT -05:00) EST5EDT"
            },
            {
                offset:"-05:00",
                id:"Etc/GMT+5",
                name:"(GMT -05:00) Etc/GMT+5"
            },
            {
                offset:"-05:00",
                id:"Jamaica",
                name:"(GMT -05:00) Jamaica"
            },
            {
                offset:"-05:00",
                id:"Pacific/Easter",
                name:"(GMT -05:00) Pacific/Easter"
            },
            {
                offset:"-05:00",
                id:"US/East-Indiana",
                name:"(GMT -05:00) US/East-Indiana"
            },
            {
                offset:"-05:00",
                id:"US/Eastern",
                name:"(GMT -05:00) US/Eastern"
            },
            {
                offset:"-05:00",
                id:"US/Michigan",
                name:"(GMT -05:00) US/Michigan"
            },
            {
                offset:"-04:30",
                id:"America/Caracas",
                name:"(GMT -04:30) America/Caracas"
            },
            {
                offset:"-04:00",
                id:"America/Anguilla",
                name:"(GMT -04:00) America/Anguilla"
            },
            {
                offset:"-04:00",
                id:"America/Antigua",
                name:"(GMT -04:00) America/Antigua"
            },
            {
                offset:"-04:00",
                id:"America/Aruba",
                name:"(GMT -04:00) America/Aruba"
            },
            {
                offset:"-04:00",
                id:"America/Barbados",
                name:"(GMT -04:00) America/Barbados"
            },
            {
                offset:"-04:00",
                id:"America/Blanc-Sablon",
                name:"(GMT -04:00) America/Blanc-Sablon"
            },
            {
                offset:"-04:00",
                id:"America/Boa_Vista",
                name:"(GMT -04:00) America/Boa_Vista"
            },
            {
                offset:"-04:00",
                id:"America/Curacao",
                name:"(GMT -04:00) America/Curacao"
            },
            {
                offset:"-04:00",
                id:"America/Dominica",
                name:"(GMT -04:00) America/Dominica"
            },
            {
                offset:"-04:00",
                id:"America/Glace_Bay",
                name:"(GMT -04:00) America/Glace_Bay"
            },
            {
                offset:"-04:00",
                id:"America/Goose_Bay",
                name:"(GMT -04:00) America/Goose_Bay"
            },
            {
                offset:"-04:00",
                id:"America/Grand_Turk",
                name:"(GMT -04:00) America/Grand_Turk"
            },
            {
                offset:"-04:00",
                id:"America/Grenada",
                name:"(GMT -04:00) America/Grenada"
            },
            {
                offset:"-04:00",
                id:"America/Guadeloupe",
                name:"(GMT -04:00) America/Guadeloupe"
            },
            {
                offset:"-04:00",
                id:"America/Guyana",
                name:"(GMT -04:00) America/Guyana"
            },
            {
                offset:"-04:00",
                id:"America/Halifax",
                name:"(GMT -04:00) America/Halifax"
            },
            {
                offset:"-04:00",
                id:"America/Kralendijk",
                name:"(GMT -04:00) America/Kralendijk"
            },
            {
                offset:"-04:00",
                id:"America/La_Paz",
                name:"(GMT -04:00) America/La_Paz"
            },
            {
                offset:"-04:00",
                id:"America/Lower_Princes",
                name:"(GMT -04:00) America/Lower_Princes"
            },
            {
                offset:"-04:00",
                id:"America/Manaus",
                name:"(GMT -04:00) America/Manaus"
            },
            {
                offset:"-04:00",
                id:"America/Marigot",
                name:"(GMT -04:00) America/Marigot"
            },
            {
                offset:"-04:00",
                id:"America/Martinique",
                name:"(GMT -04:00) America/Martinique"
            },
            {
                offset:"-04:00",
                id:"America/Moncton",
                name:"(GMT -04:00) America/Moncton"
            },
            {
                offset:"-04:00",
                id:"America/Montserrat",
                name:"(GMT -04:00) America/Montserrat"
            },
            {
                offset:"-04:00",
                id:"America/Port_of_Spain",
                name:"(GMT -04:00) America/Port_of_Spain"
            },
            {
                offset:"-04:00",
                id:"America/Porto_Velho",
                name:"(GMT -04:00) America/Porto_Velho"
            },
            {
                offset:"-04:00",
                id:"America/Puerto_Rico",
                name:"(GMT -04:00) America/Puerto_Rico"
            },
            {
                offset:"-04:00",
                id:"America/Santo_Domingo",
                name:"(GMT -04:00) America/Santo_Domingo"
            },
            {
                offset:"-04:00",
                id:"America/St_Barthelemy",
                name:"(GMT -04:00) America/St_Barthelemy"
            },
            {
                offset:"-04:00",
                id:"America/St_Kitts",
                name:"(GMT -04:00) America/St_Kitts"
            },
            {
                offset:"-04:00",
                id:"America/St_Lucia",
                name:"(GMT -04:00) America/St_Lucia"
            },
            {
                offset:"-04:00",
                id:"America/St_Thomas",
                name:"(GMT -04:00) America/St_Thomas"
            },
            {
                offset:"-04:00",
                id:"America/St_Vincent",
                name:"(GMT -04:00) America/St_Vincent"
            },
            {
                offset:"-04:00",
                id:"America/Thule",
                name:"(GMT -04:00) America/Thule"
            },
            {
                offset:"-04:00",
                id:"America/Tortola",
                name:"(GMT -04:00) America/Tortola"
            },
            {
                offset:"-04:00",
                id:"America/Virgin",
                name:"(GMT -04:00) America/Virgin"
            },
            {
                offset:"-04:00",
                id:"Atlantic/Bermuda",
                name:"(GMT -04:00) Atlantic/Bermuda"
            },
            {
                offset:"-04:00",
                id:"Brazil/West",
                name:"(GMT -04:00) Brazil/West"
            },
            {
                offset:"-04:00",
                id:"Canada/Atlantic",
                name:"(GMT -04:00) Canada/Atlantic"
            },
            {
                offset:"-04:00",
                id:"Etc/GMT+4",
                name:"(GMT -04:00) Etc/GMT+4"
            },
            {
                offset:"-03:30",
                id:"America/St_Johns",
                name:"(GMT -03:30) America/St_Johns"
            },
            {
                offset:"-03:30",
                id:"Canada/Newfoundland",
                name:"(GMT -03:30) Canada/Newfoundland"
            },
            {
                offset:"-03:00",
                id:"America/Araguaina",
                name:"(GMT -03:00) America/Araguaina"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/Buenos_Aires",
                name:"(GMT -03:00) America/Argentina/Buenos_Aires"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/Catamarca",
                name:"(GMT -03:00) America/Argentina/Catamarca"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/ComodRivadavia",
                name:"(GMT -03:00) America/Argentina/ComodRivadavia"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/Cordoba",
                name:"(GMT -03:00) America/Argentina/Cordoba"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/Jujuy",
                name:"(GMT -03:00) America/Argentina/Jujuy"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/La_Rioja",
                name:"(GMT -03:00) America/Argentina/La_Rioja"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/Mendoza",
                name:"(GMT -03:00) America/Argentina/Mendoza"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/Rio_Gallegos",
                name:"(GMT -03:00) America/Argentina/Rio_Gallegos"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/Salta",
                name:"(GMT -03:00) America/Argentina/Salta"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/San_Juan",
                name:"(GMT -03:00) America/Argentina/San_Juan"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/San_Luis",
                name:"(GMT -03:00) America/Argentina/San_Luis"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/Tucuman",
                name:"(GMT -03:00) America/Argentina/Tucuman"
            },
            {
                offset:"-03:00",
                id:"America/Argentina/Ushuaia",
                name:"(GMT -03:00) America/Argentina/Ushuaia"
            },
            {
                offset:"-03:00",
                id:"America/Asuncion",
                name:"(GMT -03:00) America/Asuncion"
            },
            {
                offset:"-03:00",
                id:"America/Bahia",
                name:"(GMT -03:00) America/Bahia"
            },
            {
                offset:"-03:00",
                id:"America/Belem",
                name:"(GMT -03:00) America/Belem"
            },
            {
                offset:"-03:00",
                id:"America/Buenos_Aires",
                name:"(GMT -03:00) America/Buenos_Aires"
            },
            {
                offset:"-03:00",
                id:"America/Campo_Grande",
                name:"(GMT -03:00) America/Campo_Grande"
            },
            {
                offset:"-03:00",
                id:"America/Catamarca",
                name:"(GMT -03:00) America/Catamarca"
            },
            {
                offset:"-03:00",
                id:"America/Cayenne",
                name:"(GMT -03:00) America/Cayenne"
            },
            {
                offset:"-03:00",
                id:"America/Cordoba",
                name:"(GMT -03:00) America/Cordoba"
            },
            {
                offset:"-03:00",
                id:"America/Cuiaba",
                name:"(GMT -03:00) America/Cuiaba"
            },
            {
                offset:"-03:00",
                id:"America/Fortaleza",
                name:"(GMT -03:00) America/Fortaleza"
            },
            {
                offset:"-03:00",
                id:"America/Godthab",
                name:"(GMT -03:00) America/Godthab"
            },
            {
                offset:"-03:00",
                id:"America/Jujuy",
                name:"(GMT -03:00) America/Jujuy"
            },
            {
                offset:"-03:00",
                id:"America/Maceio",
                name:"(GMT -03:00) America/Maceio"
            },
            {
                offset:"-03:00",
                id:"America/Mendoza",
                name:"(GMT -03:00) America/Mendoza"
            },
            {
                offset:"-03:00",
                id:"America/Miquelon",
                name:"(GMT -03:00) America/Miquelon"
            },
            {
                offset:"-03:00",
                id:"America/Paramaribo",
                name:"(GMT -03:00) America/Paramaribo"
            },
            {
                offset:"-03:00",
                id:"America/Recife",
                name:"(GMT -03:00) America/Recife"
            },
            {
                offset:"-03:00",
                id:"America/Rosario",
                name:"(GMT -03:00) America/Rosario"
            },
            {
                offset:"-03:00",
                id:"America/Santarem",
                name:"(GMT -03:00) America/Santarem"
            },
            {
                offset:"-03:00",
                id:"America/Santiago",
                name:"(GMT -03:00) America/Santiago"
            },
            {
                offset:"-03:00",
                id:"Antarctica/Palmer",
                name:"(GMT -03:00) Antarctica/Palmer"
            },
            {
                offset:"-03:00",
                id:"Antarctica/Rothera",
                name:"(GMT -03:00) Antarctica/Rothera"
            },
            {
                offset:"-03:00",
                id:"Atlantic/Stanley",
                name:"(GMT -03:00) Atlantic/Stanley"
            },
            {
                offset:"-03:00",
                id:"Chile/Continental",
                name:"(GMT -03:00) Chile/Continental"
            },
            {
                offset:"-03:00",
                id:"Etc/GMT+3",
                name:"(GMT -03:00) Etc/GMT+3"
            },
            {
                offset:"-02:00",
                id:"America/Montevideo",
                name:"(GMT -02:00) America/Montevideo"
            },
            {
                offset:"-02:00",
                id:"America/Noronha",
                name:"(GMT -02:00) America/Noronha"
            },
            {
                offset:"-02:00",
                id:"America/Sao_Paulo",
                name:"(GMT -02:00) America/Sao_Paulo"
            },
            {
                offset:"-02:00",
                id:"Atlantic/South_Georgia",
                name:"(GMT -02:00) Atlantic/South_Georgia"
            },
            {
                offset:"-02:00",
                id:"Brazil/DeNoronha",
                name:"(GMT -02:00) Brazil/DeNoronha"
            },
            {
                offset:"-02:00",
                id:"Brazil/East",
                name:"(GMT -02:00) Brazil/East"
            },
            {
                offset:"-02:00",
                id:"Etc/GMT+2",
                name:"(GMT -02:00) Etc/GMT+2"
            },
            {
                offset:"-01:00",
                id:"America/Scoresbysund",
                name:"(GMT -01:00) America/Scoresbysund"
            },
            {
                offset:"-01:00",
                id:"Atlantic/Azores",
                name:"(GMT -01:00) Atlantic/Azores"
            },
            {
                offset:"-01:00",
                id:"Atlantic/Cape_Verde",
                name:"(GMT -01:00) Atlantic/Cape_Verde"
            },
            {
                offset:"-01:00",
                id:"Etc/GMT+1",
                name:"(GMT -01:00) Etc/GMT+1"
            },
            {
                offset:"+00:00",
                id:"Africa/Abidjan",
                name:"(GMT +00:00) Africa/Abidjan"
            },
            {
                offset:"+00:00",
                id:"Africa/Accra",
                name:"(GMT +00:00) Africa/Accra"
            },
            {
                offset:"+00:00",
                id:"Africa/Bamako",
                name:"(GMT +00:00) Africa/Bamako"
            },
            {
                offset:"+00:00",
                id:"Africa/Banjul",
                name:"(GMT +00:00) Africa/Banjul"
            },
            {
                offset:"+00:00",
                id:"Africa/Bissau",
                name:"(GMT +00:00) Africa/Bissau"
            },
            {
                offset:"+00:00",
                id:"Africa/Casablanca",
                name:"(GMT +00:00) Africa/Casablanca"
            },
            {
                offset:"+00:00",
                id:"Africa/Conakry",
                name:"(GMT +00:00) Africa/Conakry"
            },
            {
                offset:"+00:00",
                id:"Africa/Dakar",
                name:"(GMT +00:00) Africa/Dakar"
            },
            {
                offset:"+00:00",
                id:"Africa/El_Aaiun",
                name:"(GMT +00:00) Africa/El_Aaiun"
            },
            {
                offset:"+00:00",
                id:"Africa/Freetown",
                name:"(GMT +00:00) Africa/Freetown"
            },
            {
                offset:"+00:00",
                id:"Africa/Lome",
                name:"(GMT +00:00) Africa/Lome"
            },
            {
                offset:"+00:00",
                id:"Africa/Monrovia",
                name:"(GMT +00:00) Africa/Monrovia"
            },
            {
                offset:"+00:00",
                id:"Africa/Nouakchott",
                name:"(GMT +00:00) Africa/Nouakchott"
            },
            {
                offset:"+00:00",
                id:"Africa/Ouagadougou",
                name:"(GMT +00:00) Africa/Ouagadougou"
            },
            {
                offset:"+00:00",
                id:"Africa/Sao_Tome",
                name:"(GMT +00:00) Africa/Sao_Tome"
            },
            {
                offset:"+00:00",
                id:"Africa/Timbuktu",
                name:"(GMT +00:00) Africa/Timbuktu"
            },
            {
                offset:"+00:00",
                id:"America/Danmarkshavn",
                name:"(GMT +00:00) America/Danmarkshavn"
            },
            {
                offset:"+00:00",
                id:"Antarctica/Troll",
                name:"(GMT +00:00) Antarctica/Troll"
            },
            {
                offset:"+00:00",
                id:"Atlantic/Canary",
                name:"(GMT +00:00) Atlantic/Canary"
            },
            {
                offset:"+00:00",
                id:"Atlantic/Faeroe",
                name:"(GMT +00:00) Atlantic/Faeroe"
            },
            {
                offset:"+00:00",
                id:"Atlantic/Faroe",
                name:"(GMT +00:00) Atlantic/Faroe"
            },
            {
                offset:"+00:00",
                id:"Atlantic/Madeira",
                name:"(GMT +00:00) Atlantic/Madeira"
            },
            {
                offset:"+00:00",
                id:"Atlantic/Reykjavik",
                name:"(GMT +00:00) Atlantic/Reykjavik"
            },
            {
                offset:"+00:00",
                id:"Atlantic/St_Helena",
                name:"(GMT +00:00) Atlantic/St_Helena"
            },
            {
                offset:"+00:00",
                id:"Eire",
                name:"(GMT +00:00) Eire"
            },
            {
                offset:"+00:00",
                id:"Etc/GMT",
                name:"(GMT +00:00) Etc/GMT"
            },
            {
                offset:"+00:00",
                id:"Etc/GMT+0",
                name:"(GMT +00:00) Etc/GMT+0"
            },
            {
                offset:"+00:00",
                id:"Etc/GMT-0",
                name:"(GMT +00:00) Etc/GMT-0"
            },
            {
                offset:"+00:00",
                id:"Etc/GMT0",
                name:"(GMT +00:00) Etc/GMT0"
            },
            {
                offset:"+00:00",
                id:"Etc/Greenwich",
                name:"(GMT +00:00) Etc/Greenwich"
            },
            {
                offset:"+00:00",
                id:"Etc/UCT",
                name:"(GMT +00:00) Etc/UCT"
            },
            {
                offset:"+00:00",
                id:"Etc/UTC",
                name:"(GMT +00:00) Etc/UTC"
            },
            {
                offset:"+00:00",
                id:"Etc/Universal",
                name:"(GMT +00:00) Etc/Universal"
            },
            {
                offset:"+00:00",
                id:"Etc/Zulu",
                name:"(GMT +00:00) Etc/Zulu"
            },
            {
                offset:"+00:00",
                id:"Europe/Belfast",
                name:"(GMT +00:00) Europe/Belfast"
            },
            {
                offset:"+00:00",
                id:"Europe/Dublin",
                name:"(GMT +00:00) Europe/Dublin"
            },
            {
                offset:"+00:00",
                id:"Europe/Guernsey",
                name:"(GMT +00:00) Europe/Guernsey"
            },
            {
                offset:"+00:00",
                id:"Europe/Isle_of_Man",
                name:"(GMT +00:00) Europe/Isle_of_Man"
            },
            {
                offset:"+00:00",
                id:"Europe/Jersey",
                name:"(GMT +00:00) Europe/Jersey"
            },
            {
                offset:"+00:00",
                id:"Europe/Lisbon",
                name:"(GMT +00:00) Europe/Lisbon"
            },
            {
                offset:"+00:00",
                id:"Europe/London",
                name:"(GMT +00:00) Europe/London"
            },
            {
                offset:"+00:00",
                id:"GB",
                name:"(GMT +00:00) GB"
            },
            {
                offset:"+00:00",
                id:"GB-Eire",
                name:"(GMT +00:00) GB-Eire"
            },
            {
                offset:"+00:00",
                id:"GMT",
                name:"(GMT +00:00) GMT"
            },
            {
                offset:"+00:00",
                id:"GMT+0",
                name:"(GMT +00:00) GMT+0"
            },
            {
                offset:"+00:00",
                id:"GMT-0",
                name:"(GMT +00:00) GMT-0"
            },
            {
                offset:"+00:00",
                id:"GMT0",
                name:"(GMT +00:00) GMT0"
            },
            {
                offset:"+00:00",
                id:"Greenwich",
                name:"(GMT +00:00) Greenwich"
            },
            {
                offset:"+00:00",
                id:"Iceland",
                name:"(GMT +00:00) Iceland"
            },
            {
                offset:"+00:00",
                id:"Portugal",
                name:"(GMT +00:00) Portugal"
            },
            {
                offset:"+00:00",
                id:"UCT",
                name:"(GMT +00:00) UCT"
            },
            {
                offset:"+00:00",
                id:"UTC",
                name:"(GMT +00:00) UTC"
            },
            {
                offset:"+00:00",
                id:"Universal",
                name:"(GMT +00:00) Universal"
            },
            {
                offset:"+00:00",
                id:"WET",
                name:"(GMT +00:00) WET"
            },
            {
                offset:"+00:00",
                id:"Zulu",
                name:"(GMT +00:00) Zulu"
            },
            {
                offset:"+01:00",
                id:"Africa/Algiers",
                name:"(GMT +01:00) Africa/Algiers"
            },
            {
                offset:"+01:00",
                id:"Africa/Bangui",
                name:"(GMT +01:00) Africa/Bangui"
            },
            {
                offset:"+01:00",
                id:"Africa/Brazzaville",
                name:"(GMT +01:00) Africa/Brazzaville"
            },
            {
                offset:"+01:00",
                id:"Africa/Ceuta",
                name:"(GMT +01:00) Africa/Ceuta"
            },
            {
                offset:"+01:00",
                id:"Africa/Douala",
                name:"(GMT +01:00) Africa/Douala"
            },
            {
                offset:"+01:00",
                id:"Africa/Kinshasa",
                name:"(GMT +01:00) Africa/Kinshasa"
            },
            {
                offset:"+01:00",
                id:"Africa/Lagos",
                name:"(GMT +01:00) Africa/Lagos"
            },
            {
                offset:"+01:00",
                id:"Africa/Libreville",
                name:"(GMT +01:00) Africa/Libreville"
            },
            {
                offset:"+01:00",
                id:"Africa/Luanda",
                name:"(GMT +01:00) Africa/Luanda"
            },
            {
                offset:"+01:00",
                id:"Africa/Malabo",
                name:"(GMT +01:00) Africa/Malabo"
            },
            {
                offset:"+01:00",
                id:"Africa/Ndjamena",
                name:"(GMT +01:00) Africa/Ndjamena"
            },
            {
                offset:"+01:00",
                id:"Africa/Niamey",
                name:"(GMT +01:00) Africa/Niamey"
            },
            {
                offset:"+01:00",
                id:"Africa/Porto-Novo",
                name:"(GMT +01:00) Africa/Porto-Novo"
            },
            {
                offset:"+01:00",
                id:"Africa/Tunis",
                name:"(GMT +01:00) Africa/Tunis"
            },
            {
                offset:"+01:00",
                id:"Arctic/Longyearbyen",
                name:"(GMT +01:00) Arctic/Longyearbyen"
            },
            {
                offset:"+01:00",
                id:"Atlantic/Jan_Mayen",
                name:"(GMT +01:00) Atlantic/Jan_Mayen"
            },
            {
                offset:"+01:00",
                id:"CET",
                name:"(GMT +01:00) CET"
            },
            {
                offset:"+01:00",
                id:"Etc/GMT-1",
                name:"(GMT +01:00) Etc/GMT-1"
            },
            {
                offset:"+01:00",
                id:"Europe/Amsterdam",
                name:"(GMT +01:00) Europe/Amsterdam"
            },
            {
                offset:"+01:00",
                id:"Europe/Andorra",
                name:"(GMT +01:00) Europe/Andorra"
            },
            {
                offset:"+01:00",
                id:"Europe/Belgrade",
                name:"(GMT +01:00) Europe/Belgrade"
            },
            {
                offset:"+01:00",
                id:"Europe/Berlin",
                name:"(GMT +01:00) Europe/Berlin"
            },
            {
                offset:"+01:00",
                id:"Europe/Bratislava",
                name:"(GMT +01:00) Europe/Bratislava"
            },
            {
                offset:"+01:00",
                id:"Europe/Brussels",
                name:"(GMT +01:00) Europe/Brussels"
            },
            {
                offset:"+01:00",
                id:"Europe/Budapest",
                name:"(GMT +01:00) Europe/Budapest"
            },
            {
                offset:"+01:00",
                id:"Europe/Busingen",
                name:"(GMT +01:00) Europe/Busingen"
            },
            {
                offset:"+01:00",
                id:"Europe/Copenhagen",
                name:"(GMT +01:00) Europe/Copenhagen"
            },
            {
                offset:"+01:00",
                id:"Europe/Gibraltar",
                name:"(GMT +01:00) Europe/Gibraltar"
            },
            {
                offset:"+01:00",
                id:"Europe/Ljubljana",
                name:"(GMT +01:00) Europe/Ljubljana"
            },
            {
                offset:"+01:00",
                id:"Europe/Luxembourg",
                name:"(GMT +01:00) Europe/Luxembourg"
            },
            {
                offset:"+01:00",
                id:"Europe/Madrid",
                name:"(GMT +01:00) Europe/Madrid"
            },
            {
                offset:"+01:00",
                id:"Europe/Malta",
                name:"(GMT +01:00) Europe/Malta"
            },
            {
                offset:"+01:00",
                id:"Europe/Monaco",
                name:"(GMT +01:00) Europe/Monaco"
            },
            {
                offset:"+01:00",
                id:"Europe/Oslo",
                name:"(GMT +01:00) Europe/Oslo"
            },
            {
                offset:"+01:00",
                id:"Europe/Paris",
                name:"(GMT +01:00) Europe/Paris"
            },
            {
                offset:"+01:00",
                id:"Europe/Podgorica",
                name:"(GMT +01:00) Europe/Podgorica"
            },
            {
                offset:"+01:00",
                id:"Europe/Prague",
                name:"(GMT +01:00) Europe/Prague"
            },
            {
                offset:"+01:00",
                id:"Europe/Rome",
                name:"(GMT +01:00) Europe/Rome"
            },
            {
                offset:"+01:00",
                id:"Europe/San_Marino",
                name:"(GMT +01:00) Europe/San_Marino"
            },
            {
                offset:"+01:00",
                id:"Europe/Sarajevo",
                name:"(GMT +01:00) Europe/Sarajevo"
            },
            {
                offset:"+01:00",
                id:"Europe/Skopje",
                name:"(GMT +01:00) Europe/Skopje"
            },
            {
                offset:"+01:00",
                id:"Europe/Stockholm",
                name:"(GMT +01:00) Europe/Stockholm"
            },
            {
                offset:"+01:00",
                id:"Europe/Tirane",
                name:"(GMT +01:00) Europe/Tirane"
            },
            {
                offset:"+01:00",
                id:"Europe/Vaduz",
                name:"(GMT +01:00) Europe/Vaduz"
            },
            {
                offset:"+01:00",
                id:"Europe/Vatican",
                name:"(GMT +01:00) Europe/Vatican"
            },
            {
                offset:"+01:00",
                id:"Europe/Vienna",
                name:"(GMT +01:00) Europe/Vienna"
            },
            {
                offset:"+01:00",
                id:"Europe/Warsaw",
                name:"(GMT +01:00) Europe/Warsaw"
            },
            {
                offset:"+01:00",
                id:"Europe/Zagreb",
                name:"(GMT +01:00) Europe/Zagreb"
            },
            {
                offset:"+01:00",
                id:"Europe/Zurich",
                name:"(GMT +01:00) Europe/Zurich"
            },
            {
                offset:"+01:00",
                id:"MET",
                name:"(GMT +01:00) MET"
            },
            {
                offset:"+01:00",
                id:"Poland",
                name:"(GMT +01:00) Poland"
            },
            {
                offset:"+02:00",
                id:"Africa/Blantyre",
                name:"(GMT +02:00) Africa/Blantyre"
            },
            {
                offset:"+02:00",
                id:"Africa/Bujumbura",
                name:"(GMT +02:00) Africa/Bujumbura"
            },
            {
                offset:"+02:00",
                id:"Africa/Cairo",
                name:"(GMT +02:00) Africa/Cairo"
            },
            {
                offset:"+02:00",
                id:"Africa/Gaborone",
                name:"(GMT +02:00) Africa/Gaborone"
            },
            {
                offset:"+02:00",
                id:"Africa/Harare",
                name:"(GMT +02:00) Africa/Harare"
            },
            {
                offset:"+02:00",
                id:"Africa/Johannesburg",
                name:"(GMT +02:00) Africa/Johannesburg"
            },
            {
                offset:"+02:00",
                id:"Africa/Kigali",
                name:"(GMT +02:00) Africa/Kigali"
            },
            {
                offset:"+02:00",
                id:"Africa/Lubumbashi",
                name:"(GMT +02:00) Africa/Lubumbashi"
            },
            {
                offset:"+02:00",
                id:"Africa/Lusaka",
                name:"(GMT +02:00) Africa/Lusaka"
            },
            {
                offset:"+02:00",
                id:"Africa/Maputo",
                name:"(GMT +02:00) Africa/Maputo"
            },
            {
                offset:"+02:00",
                id:"Africa/Maseru",
                name:"(GMT +02:00) Africa/Maseru"
            },
            {
                offset:"+02:00",
                id:"Africa/Mbabane",
                name:"(GMT +02:00) Africa/Mbabane"
            },
            {
                offset:"+02:00",
                id:"Africa/Tripoli",
                name:"(GMT +02:00) Africa/Tripoli"
            },
            {
                offset:"+02:00",
                id:"Africa/Windhoek",
                name:"(GMT +02:00) Africa/Windhoek"
            },
            {
                offset:"+02:00",
                id:"Asia/Amman",
                name:"(GMT +02:00) Asia/Amman"
            },
            {
                offset:"+02:00",
                id:"Asia/Beirut",
                name:"(GMT +02:00) Asia/Beirut"
            },
            {
                offset:"+02:00",
                id:"Asia/Damascus",
                name:"(GMT +02:00) Asia/Damascus"
            },
            {
                offset:"+02:00",
                id:"Asia/Gaza",
                name:"(GMT +02:00) Asia/Gaza"
            },
            {
                offset:"+02:00",
                id:"Asia/Hebron",
                name:"(GMT +02:00) Asia/Hebron"
            },
            {
                offset:"+02:00",
                id:"Asia/Istanbul",
                name:"(GMT +02:00) Asia/Istanbul"
            },
            {
                offset:"+02:00",
                id:"Asia/Jerusalem",
                name:"(GMT +02:00) Asia/Jerusalem"
            },
            {
                offset:"+02:00",
                id:"Asia/Nicosia",
                name:"(GMT +02:00) Asia/Nicosia"
            },
            {
                offset:"+02:00",
                id:"Asia/Tel_Aviv",
                name:"(GMT +02:00) Asia/Tel_Aviv"
            },
            {
                offset:"+02:00",
                id:"EET",
                name:"(GMT +02:00) EET"
            },
            {
                offset:"+02:00",
                id:"Egypt",
                name:"(GMT +02:00) Egypt"
            },
            {
                offset:"+02:00",
                id:"Etc/GMT-2",
                name:"(GMT +02:00) Etc/GMT-2"
            },
            {
                offset:"+02:00",
                id:"Europe/Athens",
                name:"(GMT +02:00) Europe/Athens"
            },
            {
                offset:"+02:00",
                id:"Europe/Bucharest",
                name:"(GMT +02:00) Europe/Bucharest"
            },
            {
                offset:"+02:00",
                id:"Europe/Chisinau",
                name:"(GMT +02:00) Europe/Chisinau"
            },
            {
                offset:"+02:00",
                id:"Europe/Helsinki",
                name:"(GMT +02:00) Europe/Helsinki"
            },
            {
                offset:"+02:00",
                id:"Europe/Istanbul",
                name:"(GMT +02:00) Europe/Istanbul"
            },
            {
                offset:"+02:00",
                id:"Europe/Kaliningrad",
                name:"(GMT +02:00) Europe/Kaliningrad"
            },
            {
                offset:"+02:00",
                id:"Europe/Kiev",
                name:"(GMT +02:00) Europe/Kiev"
            },
            {
                offset:"+02:00",
                id:"Europe/Mariehamn",
                name:"(GMT +02:00) Europe/Mariehamn"
            },
            {
                offset:"+02:00",
                id:"Europe/Nicosia",
                name:"(GMT +02:00) Europe/Nicosia"
            },
            {
                offset:"+02:00",
                id:"Europe/Riga",
                name:"(GMT +02:00) Europe/Riga"
            },
            {
                offset:"+02:00",
                id:"Europe/Sofia",
                name:"(GMT +02:00) Europe/Sofia"
            },
            {
                offset:"+02:00",
                id:"Europe/Tallinn",
                name:"(GMT +02:00) Europe/Tallinn"
            },
            {
                offset:"+02:00",
                id:"Europe/Tiraspol",
                name:"(GMT +02:00) Europe/Tiraspol"
            },
            {
                offset:"+02:00",
                id:"Europe/Uzhgorod",
                name:"(GMT +02:00) Europe/Uzhgorod"
            },
            {
                offset:"+02:00",
                id:"Europe/Vilnius",
                name:"(GMT +02:00) Europe/Vilnius"
            },
            {
                offset:"+02:00",
                id:"Europe/Zaporozhye",
                name:"(GMT +02:00) Europe/Zaporozhye"
            },
            {
                offset:"+02:00",
                id:"Israel",
                name:"(GMT +02:00) Israel"
            },
            {
                offset:"+02:00",
                id:"Libya",
                name:"(GMT +02:00) Libya"
            },
            {
                offset:"+02:00",
                id:"Turkey",
                name:"(GMT +02:00) Turkey"
            },
            {
                offset:"+03:00",
                id:"Africa/Addis_Ababa",
                name:"(GMT +03:00) Africa/Addis_Ababa"
            },
            {
                offset:"+03:00",
                id:"Africa/Asmara",
                name:"(GMT +03:00) Africa/Asmara"
            },
            {
                offset:"+03:00",
                id:"Africa/Asmera",
                name:"(GMT +03:00) Africa/Asmera"
            },
            {
                offset:"+03:00",
                id:"Africa/Dar_es_Salaam",
                name:"(GMT +03:00) Africa/Dar_es_Salaam"
            },
            {
                offset:"+03:00",
                id:"Africa/Djibouti",
                name:"(GMT +03:00) Africa/Djibouti"
            },
            {
                offset:"+03:00",
                id:"Africa/Juba",
                name:"(GMT +03:00) Africa/Juba"
            },
            {
                offset:"+03:00",
                id:"Africa/Kampala",
                name:"(GMT +03:00) Africa/Kampala"
            },
            {
                offset:"+03:00",
                id:"Africa/Khartoum",
                name:"(GMT +03:00) Africa/Khartoum"
            },
            {
                offset:"+03:00",
                id:"Africa/Mogadishu",
                name:"(GMT +03:00) Africa/Mogadishu"
            },
            {
                offset:"+03:00",
                id:"Africa/Nairobi",
                name:"(GMT +03:00) Africa/Nairobi"
            },
            {
                offset:"+03:00",
                id:"Antarctica/Syowa",
                name:"(GMT +03:00) Antarctica/Syowa"
            },
            {
                offset:"+03:00",
                id:"Asia/Aden",
                name:"(GMT +03:00) Asia/Aden"
            },
            {
                offset:"+03:00",
                id:"Asia/Baghdad",
                name:"(GMT +03:00) Asia/Baghdad"
            },
            {
                offset:"+03:00",
                id:"Asia/Bahrain",
                name:"(GMT +03:00) Asia/Bahrain"
            },
            {
                offset:"+03:00",
                id:"Asia/Kuwait",
                name:"(GMT +03:00) Asia/Kuwait"
            },
            {
                offset:"+03:00",
                id:"Asia/Qatar",
                name:"(GMT +03:00) Asia/Qatar"
            },
            {
                offset:"+03:00",
                id:"Asia/Riyadh",
                name:"(GMT +03:00) Asia/Riyadh"
            },
            {
                offset:"+03:00",
                id:"Etc/GMT-3",
                name:"(GMT +03:00) Etc/GMT-3"
            },
            {
                offset:"+03:00",
                id:"Europe/Minsk",
                name:"(GMT +03:00) Europe/Minsk"
            },
            {
                offset:"+03:00",
                id:"Europe/Moscow",
                name:"(GMT +03:00) Europe/Moscow"
            },
            {
                offset:"+03:00",
                id:"Europe/Simferopol",
                name:"(GMT +03:00) Europe/Simferopol"
            },
            {
                offset:"+03:00",
                id:"Europe/Volgograd",
                name:"(GMT +03:00) Europe/Volgograd"
            },
            {
                offset:"+03:00",
                id:"Indian/Antananarivo",
                name:"(GMT +03:00) Indian/Antananarivo"
            },
            {
                offset:"+03:00",
                id:"Indian/Comoro",
                name:"(GMT +03:00) Indian/Comoro"
            },
            {
                offset:"+03:00",
                id:"Indian/Mayotte",
                name:"(GMT +03:00) Indian/Mayotte"
            },
            {
                offset:"+03:00",
                id:"W-SU",
                name:"(GMT +03:00) W-SU"
            },
            {
                offset:"+03:30",
                id:"Asia/Tehran",
                name:"(GMT +03:30) Asia/Tehran"
            },
            {
                offset:"+03:30",
                id:"Iran",
                name:"(GMT +03:30) Iran"
            },
            {
                offset:"+04:00",
                id:"Asia/Baku",
                name:"(GMT +04:00) Asia/Baku"
            },
            {
                offset:"+04:00",
                id:"Asia/Dubai",
                name:"(GMT +04:00) Asia/Dubai"
            },
            {
                offset:"+04:00",
                id:"Asia/Muscat",
                name:"(GMT +04:00) Asia/Muscat"
            },
            {
                offset:"+04:00",
                id:"Asia/Tbilisi",
                name:"(GMT +04:00) Asia/Tbilisi"
            },
            {
                offset:"+04:00",
                id:"Asia/Yerevan",
                name:"(GMT +04:00) Asia/Yerevan"
            },
            {
                offset:"+04:00",
                id:"Etc/GMT-4",
                name:"(GMT +04:00) Etc/GMT-4"
            },
            {
                offset:"+04:00",
                id:"Europe/Samara",
                name:"(GMT +04:00) Europe/Samara"
            },
            {
                offset:"+04:00",
                id:"Indian/Mahe",
                name:"(GMT +04:00) Indian/Mahe"
            },
            {
                offset:"+04:00",
                id:"Indian/Mauritius",
                name:"(GMT +04:00) Indian/Mauritius"
            },
            {
                offset:"+04:00",
                id:"Indian/Reunion",
                name:"(GMT +04:00) Indian/Reunion"
            },
            {
                offset:"+04:30",
                id:"Asia/Kabul",
                name:"(GMT +04:30) Asia/Kabul"
            },
            {
                offset:"+05:00",
                id:"Antarctica/Mawson",
                name:"(GMT +05:00) Antarctica/Mawson"
            },
            {
                offset:"+05:00",
                id:"Asia/Aqtau",
                name:"(GMT +05:00) Asia/Aqtau"
            },
            {
                offset:"+05:00",
                id:"Asia/Aqtobe",
                name:"(GMT +05:00) Asia/Aqtobe"
            },
            {
                offset:"+05:00",
                id:"Asia/Ashgabat",
                name:"(GMT +05:00) Asia/Ashgabat"
            },
            {
                offset:"+05:00",
                id:"Asia/Ashkhabad",
                name:"(GMT +05:00) Asia/Ashkhabad"
            },
            {
                offset:"+05:00",
                id:"Asia/Dushanbe",
                name:"(GMT +05:00) Asia/Dushanbe"
            },
            {
                offset:"+05:00",
                id:"Asia/Karachi",
                name:"(GMT +05:00) Asia/Karachi"
            },
            {
                offset:"+05:00",
                id:"Asia/Oral",
                name:"(GMT +05:00) Asia/Oral"
            },
            {
                offset:"+05:00",
                id:"Asia/Samarkand",
                name:"(GMT +05:00) Asia/Samarkand"
            },
            {
                offset:"+05:00",
                id:"Asia/Tashkent",
                name:"(GMT +05:00) Asia/Tashkent"
            },
            {
                offset:"+05:00",
                id:"Asia/Yekaterinburg",
                name:"(GMT +05:00) Asia/Yekaterinburg"
            },
            {
                offset:"+05:00",
                id:"Etc/GMT-5",
                name:"(GMT +05:00) Etc/GMT-5"
            },
            {
                offset:"+05:00",
                id:"Indian/Kerguelen",
                name:"(GMT +05:00) Indian/Kerguelen"
            },
            {
                offset:"+05:00",
                id:"Indian/Maldives",
                name:"(GMT +05:00) Indian/Maldives"
            },
            {
                offset:"+05:30",
                id:"Asia/Calcutta",
                name:"(GMT +05:30) Asia/Calcutta"
            },
            {
                offset:"+05:30",
                id:"Asia/Colombo",
                name:"(GMT +05:30) Asia/Colombo"
            },
            {
                offset:"+05:30",
                id:"Asia/Kolkata",
                name:"(GMT +05:30) Asia/Kolkata"
            },
            {
                offset:"+05:45",
                id:"Asia/Kathmandu",
                name:"(GMT +05:45) Asia/Kathmandu"
            },
            {
                offset:"+05:45",
                id:"Asia/Katmandu",
                name:"(GMT +05:45) Asia/Katmandu"
            },
            {
                offset:"+06:00",
                id:"Antarctica/Vostok",
                name:"(GMT +06:00) Antarctica/Vostok"
            },
            {
                offset:"+06:00",
                id:"Asia/Almaty",
                name:"(GMT +06:00) Asia/Almaty"
            },
            {
                offset:"+06:00",
                id:"Asia/Bishkek",
                name:"(GMT +06:00) Asia/Bishkek"
            },
            {
                offset:"+06:00",
                id:"Asia/Dacca",
                name:"(GMT +06:00) Asia/Dacca"
            },
            {
                offset:"+06:00",
                id:"Asia/Dhaka",
                name:"(GMT +06:00) Asia/Dhaka"
            },
            {
                offset:"+06:00",
                id:"Asia/Kashgar",
                name:"(GMT +06:00) Asia/Kashgar"
            },
            {
                offset:"+06:00",
                id:"Asia/Novosibirsk",
                name:"(GMT +06:00) Asia/Novosibirsk"
            },
            {
                offset:"+06:00",
                id:"Asia/Omsk",
                name:"(GMT +06:00) Asia/Omsk"
            },
            {
                offset:"+06:00",
                id:"Asia/Qyzylorda",
                name:"(GMT +06:00) Asia/Qyzylorda"
            },
            {
                offset:"+06:00",
                id:"Asia/Thimbu",
                name:"(GMT +06:00) Asia/Thimbu"
            },
            {
                offset:"+06:00",
                id:"Asia/Thimphu",
                name:"(GMT +06:00) Asia/Thimphu"
            },
            {
                offset:"+06:00",
                id:"Asia/Urumqi",
                name:"(GMT +06:00) Asia/Urumqi"
            },
            {
                offset:"+06:00",
                id:"Etc/GMT-6",
                name:"(GMT +06:00) Etc/GMT-6"
            },
            {
                offset:"+06:00",
                id:"Indian/Chagos",
                name:"(GMT +06:00) Indian/Chagos"
            },
            {
                offset:"+06:30",
                id:"Asia/Rangoon",
                name:"(GMT +06:30) Asia/Rangoon"
            },
            {
                offset:"+06:30",
                id:"Indian/Cocos",
                name:"(GMT +06:30) Indian/Cocos"
            },
            {
                offset:"+07:00",
                id:"Antarctica/Davis",
                name:"(GMT +07:00) Antarctica/Davis"
            },
            {
                offset:"+07:00",
                id:"Asia/Bangkok",
                name:"(GMT +07:00) Asia/Bangkok"
            },
            {
                offset:"+07:00",
                id:"Asia/Ho_Chi_Minh",
                name:"(GMT +07:00) Asia/Ho_Chi_Minh"
            },
            {
                offset:"+07:00",
                id:"Asia/Hovd",
                name:"(GMT +07:00) Asia/Hovd"
            },
            {
                offset:"+07:00",
                id:"Asia/Jakarta",
                name:"(GMT +07:00) Asia/Jakarta"
            },
            {
                offset:"+07:00",
                id:"Asia/Krasnoyarsk",
                name:"(GMT +07:00) Asia/Krasnoyarsk"
            },
            {
                offset:"+07:00",
                id:"Asia/Novokuznetsk",
                name:"(GMT +07:00) Asia/Novokuznetsk"
            },
            {
                offset:"+07:00",
                id:"Asia/Phnom_Penh",
                name:"(GMT +07:00) Asia/Phnom_Penh"
            },
            {
                offset:"+07:00",
                id:"Asia/Pontianak",
                name:"(GMT +07:00) Asia/Pontianak"
            },
            {
                offset:"+07:00",
                id:"Asia/Saigon",
                name:"(GMT +07:00) Asia/Saigon"
            },
            {
                offset:"+07:00",
                id:"Asia/Vientiane",
                name:"(GMT +07:00) Asia/Vientiane"
            },
            {
                offset:"+07:00",
                id:"Etc/GMT-7",
                name:"(GMT +07:00) Etc/GMT-7"
            },
            {
                offset:"+07:00",
                id:"Indian/Christmas",
                name:"(GMT +07:00) Indian/Christmas"
            },
            {
                offset:"+08:00",
                id:"Antarctica/Casey",
                name:"(GMT +08:00) Antarctica/Casey"
            },
            {
                offset:"+08:00",
                id:"Asia/Brunei",
                name:"(GMT +08:00) Asia/Brunei"
            },
            {
                offset:"+08:00",
                id:"Asia/Chita",
                name:"(GMT +08:00) Asia/Chita"
            },
            {
                offset:"+08:00",
                id:"Asia/Choibalsan",
                name:"(GMT +08:00) Asia/Choibalsan"
            },
            {
                offset:"+08:00",
                id:"Asia/Chongqing",
                name:"(GMT +08:00) Asia/Chongqing"
            },
            {
                offset:"+08:00",
                id:"Asia/Chungking",
                name:"(GMT +08:00) Asia/Chungking"
            },
            {
                offset:"+08:00",
                id:"Asia/Harbin",
                name:"(GMT +08:00) Asia/Harbin"
            },
            {
                offset:"+08:00",
                id:"Asia/Hong_Kong",
                name:"(GMT +08:00) Asia/Hong_Kong"
            },
            {
                offset:"+08:00",
                id:"Asia/Irkutsk",
                name:"(GMT +08:00) Asia/Irkutsk"
            },
            {
                offset:"+08:00",
                id:"Asia/Kuala_Lumpur",
                name:"(GMT +08:00) Asia/Kuala_Lumpur"
            },
            {
                offset:"+08:00",
                id:"Asia/Kuching",
                name:"(GMT +08:00) Asia/Kuching"
            },
            {
                offset:"+08:00",
                id:"Asia/Macao",
                name:"(GMT +08:00) Asia/Macao"
            },
            {
                offset:"+08:00",
                id:"Asia/Macau",
                name:"(GMT +08:00) Asia/Macau"
            },
            {
                offset:"+08:00",
                id:"Asia/Makassar",
                name:"(GMT +08:00) Asia/Makassar"
            },
            {
                offset:"+08:00",
                id:"Asia/Manila",
                name:"(GMT +08:00) Asia/Manila"
            },
            {
                offset:"+08:00",
                id:"Asia/Shanghai",
                name:"(GMT +08:00) Asia/Shanghai"
            },
            {
                offset:"+08:00",
                id:"Asia/Singapore",
                name:"(GMT +08:00) Asia/Singapore"
            },
            {
                offset:"+08:00",
                id:"Asia/Taipei",
                name:"(GMT +08:00) Asia/Taipei"
            },
            {
                offset:"+08:00",
                id:"Asia/Ujung_Pandang",
                name:"(GMT +08:00) Asia/Ujung_Pandang"
            },
            {
                offset:"+08:00",
                id:"Asia/Ulaanbaatar",
                name:"(GMT +08:00) Asia/Ulaanbaatar"
            },
            {
                offset:"+08:00",
                id:"Asia/Ulan_Bator",
                name:"(GMT +08:00) Asia/Ulan_Bator"
            },
            {
                offset:"+08:00",
                id:"Australia/Perth",
                name:"(GMT +08:00) Australia/Perth"
            },
            {
                offset:"+08:00",
                id:"Australia/West",
                name:"(GMT +08:00) Australia/West"
            },
            {
                offset:"+08:00",
                id:"Etc/GMT-8",
                name:"(GMT +08:00) Etc/GMT-8"
            },
            {
                offset:"+08:00",
                id:"Hongkong",
                name:"(GMT +08:00) Hongkong"
            },
            {
                offset:"+08:00",
                id:"PRC",
                name:"(GMT +08:00) PRC"
            },
            {
                offset:"+08:00",
                id:"ROC",
                name:"(GMT +08:00) ROC"
            },
            {
                offset:"+08:00",
                id:"Singapore",
                name:"(GMT +08:00) Singapore"
            },
            {
                offset:"+08:45",
                id:"Australia/Eucla",
                name:"(GMT +08:45) Australia/Eucla"
            },
            {
                offset:"+09:00",
                id:"Asia/Dili",
                name:"(GMT +09:00) Asia/Dili"
            },
            {
                offset:"+09:00",
                id:"Asia/Jayapura",
                name:"(GMT +09:00) Asia/Jayapura"
            },
            {
                offset:"+09:00",
                id:"Asia/Khandyga",
                name:"(GMT +09:00) Asia/Khandyga"
            },
            {
                offset:"+09:00",
                id:"Asia/Pyongyang",
                name:"(GMT +09:00) Asia/Pyongyang"
            },
            {
                offset:"+09:00",
                id:"Asia/Seoul",
                name:"(GMT +09:00) Asia/Seoul"
            },
            {
                offset:"+09:00",
                id:"Asia/Tokyo",
                name:"(GMT +09:00) Asia/Tokyo"
            },
            {
                offset:"+09:00",
                id:"Asia/Yakutsk",
                name:"(GMT +09:00) Asia/Yakutsk"
            },
            {
                offset:"+09:00",
                id:"Etc/GMT-9",
                name:"(GMT +09:00) Etc/GMT-9"
            },
            {
                offset:"+09:00",
                id:"Japan",
                name:"(GMT +09:00) Japan"
            },
            {
                offset:"+09:00",
                id:"Pacific/Palau",
                name:"(GMT +09:00) Pacific/Palau"
            },
            {
                offset:"+09:00",
                id:"ROK",
                name:"(GMT +09:00) ROK"
            },
            {
                offset:"+09:30",
                id:"Australia/Darwin",
                name:"(GMT +09:30) Australia/Darwin"
            },
            {
                offset:"+09:30",
                id:"Australia/North",
                name:"(GMT +09:30) Australia/North"
            },
            {
                offset:"+10:00",
                id:"Antarctica/DumontDUrville",
                name:"(GMT +10:00) Antarctica/DumontDUrville"
            },
            {
                offset:"+10:00",
                id:"Asia/Magadan",
                name:"(GMT +10:00) Asia/Magadan"
            },
            {
                offset:"+10:00",
                id:"Asia/Sakhalin",
                name:"(GMT +10:00) Asia/Sakhalin"
            },
            {
                offset:"+10:00",
                id:"Asia/Ust-Nera",
                name:"(GMT +10:00) Asia/Ust-Nera"
            },
            {
                offset:"+10:00",
                id:"Asia/Vladivostok",
                name:"(GMT +10:00) Asia/Vladivostok"
            },
            {
                offset:"+10:00",
                id:"Australia/Brisbane",
                name:"(GMT +10:00) Australia/Brisbane"
            },
            {
                offset:"+10:00",
                id:"Australia/Lindeman",
                name:"(GMT +10:00) Australia/Lindeman"
            },
            {
                offset:"+10:00",
                id:"Australia/Queensland",
                name:"(GMT +10:00) Australia/Queensland"
            },
            {
                offset:"+10:00",
                id:"Etc/GMT-10",
                name:"(GMT +10:00) Etc/GMT-10"
            },
            {
                offset:"+10:00",
                id:"Pacific/Chuuk",
                name:"(GMT +10:00) Pacific/Chuuk"
            },
            {
                offset:"+10:00",
                id:"Pacific/Guam",
                name:"(GMT +10:00) Pacific/Guam"
            },
            {
                offset:"+10:00",
                id:"Pacific/Port_Moresby",
                name:"(GMT +10:00) Pacific/Port_Moresby"
            },
            {
                offset:"+10:00",
                id:"Pacific/Saipan",
                name:"(GMT +10:00) Pacific/Saipan"
            },
            {
                offset:"+10:00",
                id:"Pacific/Truk",
                name:"(GMT +10:00) Pacific/Truk"
            },
            {
                offset:"+10:00",
                id:"Pacific/Yap",
                name:"(GMT +10:00) Pacific/Yap"
            },
            {
                offset:"+10:30",
                id:"Australia/Adelaide",
                name:"(GMT +10:30) Australia/Adelaide"
            },
            {
                offset:"+10:30",
                id:"Australia/Broken_Hill",
                name:"(GMT +10:30) Australia/Broken_Hill"
            },
            {
                offset:"+10:30",
                id:"Australia/South",
                name:"(GMT +10:30) Australia/South"
            },
            {
                offset:"+10:30",
                id:"Australia/Yancowinna",
                name:"(GMT +10:30) Australia/Yancowinna"
            },
            {
                offset:"+11:00",
                id:"Antarctica/Macquarie",
                name:"(GMT +11:00) Antarctica/Macquarie"
            },
            {
                offset:"+11:00",
                id:"Asia/Srednekolymsk",
                name:"(GMT +11:00) Asia/Srednekolymsk"
            },
            {
                offset:"+11:00",
                id:"Australia/ACT",
                name:"(GMT +11:00) Australia/ACT"
            },
            {
                offset:"+11:00",
                id:"Australia/Canberra",
                name:"(GMT +11:00) Australia/Canberra"
            },
            {
                offset:"+11:00",
                id:"Australia/Currie",
                name:"(GMT +11:00) Australia/Currie"
            },
            {
                offset:"+11:00",
                id:"Australia/Hobart",
                name:"(GMT +11:00) Australia/Hobart"
            },
            {
                offset:"+11:00",
                id:"Australia/LHI",
                name:"(GMT +11:00) Australia/LHI"
            },
            {
                offset:"+11:00",
                id:"Australia/Lord_Howe",
                name:"(GMT +11:00) Australia/Lord_Howe"
            },
            {
                offset:"+11:00",
                id:"Australia/Melbourne",
                name:"(GMT +11:00) Australia/Melbourne"
            },
            {
                offset:"+11:00",
                id:"Australia/NSW",
                name:"(GMT +11:00) Australia/NSW"
            },
            {
                offset:"+11:00",
                id:"Australia/Sydney",
                name:"(GMT +11:00) Australia/Sydney"
            },
            {
                offset:"+11:00",
                id:"Australia/Tasmania",
                name:"(GMT +11:00) Australia/Tasmania"
            },
            {
                offset:"+11:00",
                id:"Australia/Victoria",
                name:"(GMT +11:00) Australia/Victoria"
            },
            {
                offset:"+11:00",
                id:"Etc/GMT-11",
                name:"(GMT +11:00) Etc/GMT-11"
            },
            {
                offset:"+11:00",
                id:"Pacific/Bougainville",
                name:"(GMT +11:00) Pacific/Bougainville"
            },
            {
                offset:"+11:00",
                id:"Pacific/Efate",
                name:"(GMT +11:00) Pacific/Efate"
            },
            {
                offset:"+11:00",
                id:"Pacific/Guadalcanal",
                name:"(GMT +11:00) Pacific/Guadalcanal"
            },
            {
                offset:"+11:00",
                id:"Pacific/Kosrae",
                name:"(GMT +11:00) Pacific/Kosrae"
            },
            {
                offset:"+11:00",
                id:"Pacific/Noumea",
                name:"(GMT +11:00) Pacific/Noumea"
            },
            {
                offset:"+11:00",
                id:"Pacific/Pohnpei",
                name:"(GMT +11:00) Pacific/Pohnpei"
            },
            {
                offset:"+11:00",
                id:"Pacific/Ponape",
                name:"(GMT +11:00) Pacific/Ponape"
            },
            {
                offset:"+11:30",
                id:"Pacific/Norfolk",
                name:"(GMT +11:30) Pacific/Norfolk"
            },
            {
                offset:"+12:00",
                id:"Asia/Anadyr",
                name:"(GMT +12:00) Asia/Anadyr"
            },
            {
                offset:"+12:00",
                id:"Asia/Kamchatka",
                name:"(GMT +12:00) Asia/Kamchatka"
            },
            {
                offset:"+12:00",
                id:"Etc/GMT-12",
                name:"(GMT +12:00) Etc/GMT-12"
            },
            {
                offset:"+12:00",
                id:"Kwajalein",
                name:"(GMT +12:00) Kwajalein"
            },
            {
                offset:"+12:00",
                id:"Pacific/Funafuti",
                name:"(GMT +12:00) Pacific/Funafuti"
            },
            {
                offset:"+12:00",
                id:"Pacific/Kwajalein",
                name:"(GMT +12:00) Pacific/Kwajalein"
            },
            {
                offset:"+12:00",
                id:"Pacific/Majuro",
                name:"(GMT +12:00) Pacific/Majuro"
            },
            {
                offset:"+12:00",
                id:"Pacific/Nauru",
                name:"(GMT +12:00) Pacific/Nauru"
            },
            {
                offset:"+12:00",
                id:"Pacific/Tarawa",
                name:"(GMT +12:00) Pacific/Tarawa"
            },
            {
                offset:"+12:00",
                id:"Pacific/Wake",
                name:"(GMT +12:00) Pacific/Wake"
            },
            {
                offset:"+12:00",
                id:"Pacific/Wallis",
                name:"(GMT +12:00) Pacific/Wallis"
            },
            {
                offset:"+13:00",
                id:"Antarctica/McMurdo",
                name:"(GMT +13:00) Antarctica/McMurdo"
            },
            {
                offset:"+13:00",
                id:"Antarctica/South_Pole",
                name:"(GMT +13:00) Antarctica/South_Pole"
            },
            {
                offset:"+13:00",
                id:"Etc/GMT-13",
                name:"(GMT +13:00) Etc/GMT-13"
            },
            {
                offset:"+13:00",
                id:"NZ",
                name:"(GMT +13:00) NZ"
            },
            {
                offset:"+13:00",
                id:"Pacific/Auckland",
                name:"(GMT +13:00) Pacific/Auckland"
            },
            {
                offset:"+13:00",
                id:"Pacific/Enderbury",
                name:"(GMT +13:00) Pacific/Enderbury"
            },
            {
                offset:"+13:00",
                id:"Pacific/Fakaofo",
                name:"(GMT +13:00) Pacific/Fakaofo"
            },
            {
                offset:"+13:00",
                id:"Pacific/Fiji",
                name:"(GMT +13:00) Pacific/Fiji"
            },
            {
                offset:"+13:00",
                id:"Pacific/Tongatapu",
                name:"(GMT +13:00) Pacific/Tongatapu"
            },
            {
                offset:"+13:45",
                id:"NZ-CHAT",
                name:"(GMT +13:45) NZ-CHAT"
            },
            {
                offset:"+13:45",
                id:"Pacific/Chatham",
                name:"(GMT +13:45) Pacific/Chatham"
            },
            {
                offset:"+14:00",
                id:"Etc/GMT-14",
                name:"(GMT +14:00) Etc/GMT-14"
            },
            {
                offset:"+14:00",
                id:"Pacific/Apia",
                name:"(GMT +14:00) Pacific/Apia"
            },
            {
                offset:"+14:00",
                id:"Pacific/Kiritimati",
                name:"(GMT +14:00) Pacific/Kiritimati"
            }
        ]
    },
    getters: {
        timezones: state => {
            return state.timezones
        },
        lang: state => {
            return state.lang
        },
        api: state => {
            return state.api
        },
        ApiExportPreviousRequests: state => {
            return state.ApiExportPreviousRequests
        },
        path: state => {
            return state.path ? state.path.trimChars('/') : 'default'
        },
        modules: state => {
            return state.modules
        },
        debugApiUrl: state => {
            return state.debugApiUrl
        },
        isLoggedIn: state => {
            return state.isLoggedIn
        },
        loaded: state => {
            return state.loaded
        },
        user: state => {
            return state.user
        },
        scope: state => {
            return state.scope
        },
        scopes: state => {
            return state.scopes
        },
        workspace: state => {
            return state.workspace
        },
        countries: state => {
            var countries = {}
            for (let item of state.countries) {
                countries[item.id.toUpperCase()] = item.name
            }
            return countries
        },
        countriesGrouped: state => {
            return {
                options: state.countriesGrouped,
                value: []
            }
        }
    },
    mutations: {
        [CHECK_SUCCESS] (state) {
            state.isLoggedIn = true;
            state.pending = false;
        },
        [LOGIN] (state) {
            state.pending = true;
        },
        [LOGIN_SUCCESS] (state) {
            state.isLoggedIn = true;
            state.pending = false;
        },
        [LOGOUT](state) {
            state.isLoggedIn = false;
        },
        [CLIENT_SWITCHED](state) {
            //console.log("CLIENT_SWITCHED", state.scope.id)
            localStorage.setItem('scope', state.scope.id)
        },
        [WORKSPACE_SWITCHED](state) {
            //console.log("WORKSPACE_SWITCHED", state.workspace)
            localStorage.setItem('workspace', state.workspace.id)
        }
    },
    actions: {
        switchScope({ commit }, slug){
            return new Promise((resolve, reject) => {

                this.state.path = slug ? '/' + slug : slug;
                this.state.debugApiUrl = window.apiUrl + this.state.path + '/v1/admin';
                window.axios.defaults.baseURL = this.state.debugApiUrl;

                setTimeout(() => {
                    for (let item of this.state.user.scopes) {
                        if( item.slug == slug ){
                            this.state.scope = item;
                            break;
                        }
                    }

                    axios.get(API_USER_ACL_URL + this.state.scope.id).then(response => {

                        this.state.user.role_id = response.data.user_role.role_id;
                        this.state.user.role_level = response.data.user_role.role_level;

                        this.state.user.acl = {
                            'accepted': response.data.accepted,
                            'denied': response.data.denied
                        };

                        commit(CLIENT_SWITCHED);
                        resolve()

                    }).catch(error => reject(error))

                }, 100)
            })
        },
        load({ commit }){
            return new Promise((resolve, reject) => {

                axios.get(API_VARIABLE, {
                    headers: {
                        'Accept': 'application/json',
                        'Accept-Language': 'fr-CH'
                    }
                }).then(response => {

                    console.log('LOAD',response);

                    var countries = {}
                    for (let item of response.data.countries) {
                        countries[item.id] = item
                    }

                    var countriesGroupedId = []
                    var countriesGrouped = []
                    for (let item of response.data.countries) {
                        if( countriesGroupedId.indexOf(item.region) < 0 && item.region ){
                            countriesGroupedId.push(item.region);
                            var values = []
                            for (let country of response.data.countries) {
                                if( item.region == country.region){
                                    values.push(country)
                                }
                            }
                            countriesGrouped.push({
                                region: item.region,
                                values: values
                            })
                        }
                    }

                    //console.log(countriesGrouped)

                    var currencies = {}
                    for (let item of response.data.currencies) {
                        currencies[item.id] = item
                    }

                    var locales = {}
                    for (let item of response.data.locales) {
                        locales[item.id] = item
                    }

                    var taxes = {}
                    for (let item of response.data.taxes) {
                        taxes[item.id] = item
                    }

                    this.state.currencies = response.data.currencies
                    this.state.countriesGrouped = countriesGrouped
                    this.state.countries = response.data.countries
                    this.state.metrics = response.data.metrics
                    this.state.locales = response.data.locales
                    this.state.taxes = response.data.taxes
                    this.state.modules = response.data.modules
                    this.state.loaded = true

                    resolve(response)
                })

            .catch(error => reject(error))

            })
        },
        user({ commit }){
            return new Promise((resolve, reject) => {

                var config = {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        'Accept':  'application/json'
                    }
                };

                axios.get(API_USER_URL, config).then(response => {

                    this.state.user = response.data

                    for (let item of response.data.scopes) {
                        if( item.id == localStorage.getItem('scope') ){
                            this.state.scope = item;

                            // Switch Scope
                            this.state.path = item.slug ? '/' + item.slug : item.slug;
                            this.state.debugApiUrl = window.apiUrl + this.state.path + '/v1/admin';

                            window.axios.defaults.baseURL = this.state.debugApiUrl;

                            break;
                        }
                    }

                    var scopes = {}
                    for (let item of response.data.scopes) {
                        scopes[item.id] = {
                            id: item.id,
                            name: item.name,
                            slug: item.slug,
                            color: item.color,
                            is_ttc: item.is_ttc,
                            children: item.children
                        }
                    }

                    this.state.scopes = scopes;

                    if( this.state.scope.id )
                    {
                        // Get ACL for current Scope
                        axios.get(API_USER_ACL_URL + this.state.scope.id).then(response => {
                            this.state.user.role_id = response.data.user_role.role_id;
                            this.state.user.role_level = response.data.user_role.role_level;
                            this.state.user.acl = {
                                'accepted': response.data.accepted,
                                'denied': response.data.denied
                            };

                            commit(CHECK_SUCCESS);
                            resolve(response)

                        }).catch(error => reject(error))
                    }else{
                        commit(CHECK_SUCCESS);
                        resolve(response)
                    }



                }).catch(error => reject(error))

            })
        },
        login({ commit }, creds){

            localStorage.removeItem('token')
            localStorage.removeItem('workspace')
            localStorage.removeItem('scope')

            this.state.scope = null

            commit(LOGIN); // show spinner
            return new Promise((resolve, reject) => {
                    axios.post(API_LOGIN_URL, creds)
                    .then(response => {
                        console.log('LOAD LOGIN', response.data)

                        localStorage.setItem('weebox.login.username', response.data.user.email)

                        var scopes = {}
                        for (let item of response.data.user.scopes) {
                            scopes[item.id] = {
                                id: item.id,
                                name: item.name,
                                slug: item.slug,
                                color: item.color,
                                children: item.children
                            }
                        }
                        this.state.scopes = scopes;

                        localStorage.setItem('token', response.data.token)
                        this.state.user = response.data.user
                        commit(LOGIN_SUCCESS);
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        logout({ commit }) {

            //localStorage.removeItem('weebox.login.username')
            localStorage.removeItem("token")
            localStorage.removeItem('workspace')
            localStorage.removeItem('scope')
            this.state.user = null
            this.state.isLoggedIn = false
            commit(LOGOUT);
        }
    }
})


// WEBPACK FOOTER //
// ./src/store.js